import { render, staticRenderFns } from "./Vacancies.vue?vue&type=template&id=1aa43dd0&scoped=true&"
import script from "./Vacancies.vue?vue&type=script&lang=js&"
export * from "./Vacancies.vue?vue&type=script&lang=js&"
import style0 from "./Vacancies.vue?vue&type=style&index=0&id=1aa43dd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa43dd0",
  null
  
)

/* custom blocks */
import block0 from "./Vacancies.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./Vacancies.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VAlert,VCol,VRow,VTab,VTabItem,VTabs,VTabsItems})
